export default __webpack_public_path__ + "static/media/IAF-logo.637d40de.jpg";